module.exports = __webpack_public_path__ + "img/3-blockers.2df143a8.svg";